import { useEffect } from "react";
import { DarkmodeAction } from "../../store/slices/darkmodeSlice";
import { useAppDispatch } from "../../store/store";
import { useSelector } from "react-redux";
import { MoonIcon, SunIcon } from "@heroicons/react/24/solid";
import { useUpdateDarkModeMutation } from "@lxp-app/store/slices/api/darkModeApiSlice";

export default function Switcher() {
  const dispatch = useAppDispatch();
  const mode = useSelector((state: any) => state.DarkmodeSlice);
  const { isDarkMode } = mode;
  const [updateDarkMode, { isLoading }] = useUpdateDarkModeMutation();

  useEffect(() => {
    const html = document.documentElement;
    if (isDarkMode) {
      html.classList.add("dark");
    } else {
      html.classList.remove("dark");
    }
  }, [isDarkMode]);

  const toggleDarkMode = () => {
    const modeValue = !isDarkMode ? "dark" : "light";
    dispatch(DarkmodeAction.setDarkMode(!isDarkMode));
    updateDarkMode({ modeValue })
      .unwrap()
      .then((_res) => {})
      .catch((error) => {
        console.error("API call failed:", error);
      });
  };

  return (
    <button
      type="button"
      onClick={!isLoading ? toggleDarkMode : undefined}
      disabled={isLoading}
      aria-label={isDarkMode ? "Switch to light mode" : "Switch to dark mode"}
      className="cursor-pointer rounded-md focus:outline-none focus-visible:ring-2 focus-visible:ring-dark-widget disabled:cursor-not-allowed disabled:opacity-60"
    >
      {isDarkMode ? (
        <MoonIcon aria-hidden="true" className="h-8 text-[#6699CC]" />
      ) : (
        <SunIcon aria-hidden="true" className="h-8 text-[#FDB813]" />
      )}
    </button>
  );
}
